/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useCallback, useEffect } from "react";
import {
  Grid,
  Box,
  Typography,
  IconButton,
  Tooltip,
  CircularProgress,
} from "@material-ui/core";
import ToolkitTable from "components/Cards/Tables/ToolkitTable";
import {
  columnNumberField,
  columnDateField,
  sortableField,
  columnTextField,
} from "utils/tables-utils";
import PrintButton from "components/_refactor/button/print";
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";

import MaskAndValid from "utils/maskAndValid";
import UtilsFncs from "utils/UtilsFncs";

import { useWebsocketFetch } from "hooks/useWebsocketFetch";
import { useVisionLogin } from "hooks/useVisionLogin";
import { utils, writeFileXLSX } from "xlsx";

import {
  LocalShipping as LocalShippingIcon,
  AddCircle as AddCircleIcon,
} from "@material-ui/icons";

import IconButtonLoader from "components/Buttons/IconButtonLoader";
import { API_ENV } from "constants/environment";
import { IsMobile } from "../../../utils/is-mobile";

const exportIconStyle = {
  width: 25,
  height: 25,
};

const getColumnModel = (setOcorrenciaRegistroRow, setOrderDetails) => [
  columnTextField(
    {
      dataField: "Cliente",
      text: "Cliente",
    },
    true
  ),
  columnDateField(
    {
      dataField: "DataDigitacaoPedido",
      text: "Data Digitação Pedido",
    },
    true
  ),
  sortableField({
    dataField: "Marketplace",
    text: "Marketplace / Loja",
    align: "center",
    headerAlign: "center",
  }),
  sortableField({
    dataField: "NrPedido",
    text: "Numero Pedido",
    align: "center",
    headerAlign: "center",
    formatter: (cell) => {
      return (
        <div
          style={{ textDecoration: "underline", cursor: "pointer" }}
          onClick={() => setOrderDetails(cell)}
        >
          {cell}
        </div>
      );
    },
  }),
  columnNumberField(
    {
      dataField: "NrPedidoCliente",
      text: "Numero Pedido Cliente",
    },
    true
  ),
  columnNumberField(
    {
      dataField: "NumeroNF",
      text: "Numero NF",
    },
    true
  ),
  sortableField({
    dataField: "Status",
    text: "Status Pedido",
    align: "center",
    headerAlign: "center",
    formatter: (cell) => {
      let sentence = cell;
      sentence = sentence?.toLowerCase()?.replace(/(?:^|\s)\S/g, function (a) {
        return a?.toUpperCase();
      });
      return cell ? <span>{UtilsFncs.Truncate(sentence, 50)}</span> : null;
    },
  }),
  columnTextField(
    {
      dataField: "DataPrevisaoEntregaFormat",
      text: "Data Prevista de Entrega",
      align: "center",
      headerAlign: "center",
    },
    true
  ),
  sortableField({
    dataField: "Transportadora",
    text: "Transportadora",
    align: "center",
    headerAlign: "center",
  }),
  sortableField({
    dataField: "UltimaOcorrencia",
    text: "Status Ocorrência",
    align: "center",
    headerAlign: "center",
    formatter: (cell, row) => {
      let sentence = cell;
      sentence = sentence?.toLowerCase()?.replace(/(?:^|\s)\S/g, function (a) {
        return a?.toUpperCase();
      });
      return cell ? (
        <Tooltip
          title={row?.LocalOcorrencia ? row?.LocalOcorrencia : ""}
          placement="bottom"
        >
          <span>{UtilsFncs.Truncate(sentence, 50)}</span>
        </Tooltip>
      ) : null;
    },
  }),
  columnTextField(
    {
      dataField: "OcorrenciaEntrega",
      text: "Ocorrência do Pedido",
      align: "center",
      headerAlign: "center",
    },
    true
  ),
  {
    dataField: "registrarObservacao",
    isDummyField: true,
    text: "Registrar Ocorrência do Pedido",
    sort: false,
    headerAlign: "center",
    formatter: (cell, row) => (
      <div style={{ display: "flex", justifyContent: "center" }}>
        {!MaskAndValid.isNullOrEmpty(row.NrPedido) ? (
          <IconButton
            title="Registrar Observação de Entrega"
            size="small"
            style={{ color: "rgba(0, 0, 0, 0.54)", padding: 6 }}
            onClick={() => setOcorrenciaRegistroRow(row)}
          >
            <AddCircleIcon />
          </IconButton>
        ) : null}
      </div>
    ),
    csvExport: false,
  },
  {
    dataField: "verOcorrencias",
    isDummyField: true,
    text: "Rastreio",
    align: "center",
    headerAlign: "center",
    sort: false,
    formatter: (cell, row) => (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {!MaskAndValid.isNullOrEmpty(row.NrPedido) ? (
          <IconButton
            component="a"
            href={row?.LinkRastreio}
            target="_blank"
            rel="noreferrer"
            title="Ver Ocorrências de Entrega"
            size="small"
            style={{ color: "rgba(0, 0, 0, 0.54)", padding: 6 }}
          >
            <LocalShippingIcon />
          </IconButton>
        ) : null}
      </div>
    ),
    csvExport: false,
  },
];

export const TableConsultaPedidosOmni = ({
  dataTable,
  setOcorrenciaRegistroRow,
  setOrderDetails,
  totalRegisters,
  currentPage,
  currentSizePerPage,
  handleSearch,
  labelHeader,
  lastSearchParams,
}) => {
  const snackbar = useSnackbar();

  const { userId } = useVisionLogin();

  const [loading, setLoading] = useState(false);
  const [sendRequestExport, setSendRequestExport] = useState(null);

  const isMobile = IsMobile();

  const { data, handleFetchData, status, handleFetchUrl } = useWebsocketFetch({
    onSuccess: handleDownloadXML,
  });

  const doSearch = useCallback(async (page, sizePerPage) => {
    setLoading(true);

    await handleSearch({ page, sizePerPage });

    setLoading(false);
  }, []);

  const handlePageChange = useCallback(
    (page, sizePerPage) => {
      doSearch(page, sizePerPage);
    },
    [doSearch]
  );

  const handleSizePerPageChange = useCallback(
    (sizePerPage, page) => {
      doSearch(page, sizePerPage);
    },
    [doSearch]
  );

  const handleSendMessage = (message) => {
    handleFetchData(message);
    snackbar.showMessage("Aguarde exportação do relatório.", {
      severity: "info",
      autoHideDuration: 60000,
    });
  };

  function handleDownloadXML() {
    const receipt = utils.json_to_sheet(data);

    const wb = utils.book_new();
    utils.book_append_sheet(wb, receipt, "ConsultaPedidosOmni");
    writeFileXLSX(wb, "ConsultaPedidosOmni.xlsx");
  }

  const exportCmp =
    status === "on" ? (
      <>
        <span>
          <Tooltip title="Exportar tudo">
            <IconButtonLoader
              onClick={() => handleSendMessage(sendRequestExport)}
              icon={
                <img
                  src="https://img.icons8.com/material-outlined/72/000000/xls-export.png"
                  alt="ícone clicável para exportar a tabela no formato Excel"
                  style={exportIconStyle}
                />
              }
              size="small"
            />
          </Tooltip>
        </span>
      </>
    ) : status === "fetching" ? (
      <span>
        <CircularProgress style={exportIconStyle} />
      </span>
    ) : null;

  useEffect(() => {
    if (status === "empty") {
      snackbar.showMessage("Sua busca não retornou nenhum resultado.", {
        severity: "success",
      });
    }
  }, [status]);

  useEffect(() => {
    if (lastSearchParams && userId) {
      setSendRequestExport({
        action: "list-ecommerce-orders",
        params: {
          querystring: lastSearchParams,
          header: {
            "K-IdUser": userId,
          },
        },
      });
    }
  }, [lastSearchParams, userId]);

  useEffect(() => {
    handleFetchUrl(
      `wss://9927ji77ol.execute-api.us-east-1.amazonaws.com/${API_ENV}`
    );
  }, []);

  return (
    <ToolkitTable
      searched={Boolean(dataTable)}
      keyField="NumeroNF"
      dataTable={dataTable}
      columnModel={getColumnModel(setOcorrenciaRegistroRow, setOrderDetails)}
      headerTitle={labelHeader}
      csvFileName="ConsultaPedidosOmni.csv"
      showSearch={false}
      showPrint
      loading={loading}
      pagination={{
        options: [25, 50, 100],
        defaultOption: currentSizePerPage,
        showTotal: true,
        totalSize: totalRegisters,
        page: currentPage,
        onPageChange: handlePageChange,
        sizePerPage: currentSizePerPage,
        onSizePerPageChange: handleSizePerPageChange,
      }}
      CustomHeader={({ componentRefProps, selectRefProps }) => (
        <Grid
          container
          className="pl-4"
          style={{ padding: "0 24px", marginBottom: "1rem" }}
        >
          <Grid
            item
            xs={12}
            sm={6}
            style={{ display: "flex", alignItems: "center" }}
          >
            <Box component={Typography} variant="h2" marginBottom="0!important">
              <Box component="span">{labelHeader}</Box>
            </Box>
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: isMobile ? "flex-start" : "flex-end",
              padding: 0,
              marginBottom: "0.5rem!important",
              marginTop: isMobile && "0.5rem",
            }}
          >
            <Box
              justifyContent="flex-end"
              alignItems="center"
              display="flex"
              flexWrap="wrap"
              style={{ marginLeft: 15, marginRight: 15, cursor: "pointer" }}
            >
              {exportCmp}
            </Box>
            <Box
              justifyContent="flex-end"
              alignItems="center"
              display="flex"
              flexWrap="wrap"
              style={{
                marginLeft: isMobile ? 0 : 15,
                marginRight: 15,
                cursor: "pointer",
              }}
            >
              <PrintButton
                selectRef={selectRefProps}
                componentRef={componentRefProps}
                dataTable={dataTable}
              />
            </Box>
          </Grid>
        </Grid>
      )}
      bootstrapTableProps={{
        remote: true,
        onTableChange: () => {},
      }}
      notFoundTitle="Sua pesquisa não encontrou nenhum pedido."
    />
  );
};
